import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ds_null from "../assets/img/enum/Doc_stat/1.png";
import ds_1 from "../assets/img/enum/Doc_stat/2.png";
import ds_2 from "../assets/img/enum/Doc_stat/3.png";
import ds_3 from "../assets/img/enum/Doc_stat/4.png";
import ds_4 from "../assets/img/enum/Doc_stat/5.png";
import ds_5 from "../assets/img/enum/Doc_stat/6.png";
import ds_6 from "../assets/img/enum/Doc_stat/7.png";
import ds_7 from "../assets/img/enum/Doc_stat/8.png";
import ds_8 from "../assets/img/enum/Doc_stat/9.png";
import ds_9 from "../assets/img/enum/Doc_stat/10.png";
import ds_10 from "../assets/img/enum/Doc_stat/11.png";
import ds_11 from "../assets/img/enum/Doc_stat/12.png";
import ds_12 from "../assets/img/enum/Doc_stat/13.png";
import ds_13 from "../assets/img/enum/Doc_stat/14.png";
import ds_14 from "../assets/img/enum/Doc_stat/15.png";
import ds_15 from "../assets/img/enum/Doc_stat/16.png";
import ds_16 from "../assets/img/enum/Doc_stat/17.png";
import ds_17 from "../assets/img/enum/Doc_stat/18.png";
import ds_18 from "../assets/img/enum/Doc_stat/19.png";
import ds_19 from "../assets/img/enum/Doc_stat/20.png";
import ds_20 from "../assets/img/enum/Doc_stat/21.png";
import ds_21 from "../assets/img/enum/Doc_stat/22.png";
import ds_22 from "../assets/img/enum/Doc_stat/23.png";
import ds_23 from "../assets/img/enum/Doc_stat/24.png";
import ds_24 from "../assets/img/enum/Doc_stat/25.png";
import ds_25 from "../assets/img/enum/Doc_stat/26.png";
import ds_26 from "../assets/img/enum/Doc_stat/27.png";
import ds_27 from "../assets/img/enum/Doc_stat/28.png";
import ds_28 from "../assets/img/enum/Doc_stat/29.png";
import ds_29 from "../assets/img/enum/Doc_stat/30.png";
import ds_30 from "../assets/img/enum/Doc_stat/31.png";
import ds_31 from "../assets/img/enum/Doc_stat/32.png";
import ds_32 from "../assets/img/enum/Doc_stat/33.png";
import ds_33 from "../assets/img/enum/Doc_stat/34.png";
import ds_34 from "../assets/img/enum/Doc_stat/35.png";
import ds_35 from "../assets/img/enum/Doc_stat/36.png";
import ds_36 from "../assets/img/enum/Doc_stat/37.png";

class DocumentStatusImage extends Component {

  constructor(props, context) {
    super(props, context);

    this.createDocStatusImageMap();
  }

  createDocStatusImageMap = () => {
    this.statusImageMap = {
      "null": ds_null,
      "A": ds_1, "B": ds_2, "C": ds_3, "D": ds_4, "E": ds_5, "F": ds_6, "G": ds_7, "H": ds_8, "I": ds_9,
      "J": ds_10, "K": ds_11, "L": ds_12, "M": ds_13, "N": ds_14, "O": ds_15, "P": ds_16, "Q": ds_17, "R": ds_18, "S": ds_19,
      "T": ds_20, "U": ds_21, "V": ds_22, "W": ds_23, "X": ds_24, "Y": ds_25, "Z": ds_26, "0": ds_27, "1": ds_28, "2": ds_29,
      "3": ds_30, "4": ds_31, "5": ds_32, "6": ds_33, "7": ds_34, "8": ds_35, "9":ds_36
    };
  };

  render() {
    let statusImage = this.statusImageMap[this.props.statusChar ? this.props.statusChar : "null"];

    if(statusImage)
      return(
        <img src={statusImage} {...this.props}/>
      );

    return null;
  }
}

DocumentStatusImage.propTypes = {
  statusChar: PropTypes.string
};

DocumentStatusImage.defaultProps = {
  statusChar: null
};

function mapStateToProps(state, ownProps) {
  return {

  };
}

export default connect(mapStateToProps)(DocumentStatusImage);